import moment from 'moment';

const isToday = day => {
  const convertedDate = moment(day).format('YYYY-MM-DD');

  if (moment().isSame(convertedDate, 'day')) {
    return true;
  }

  return false;
};

export default isToday;
